import React, { useEffect, useRef } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify'
import PollQuestion from './SmallComponents/PollQuestion'
import Floatingbutton from './Floatingbutton'
import PageHeader from '../Elements/UI/PageHeader'
import EmptyState from '../Elements/UI/EmptyState'
import FeedSkeleton from '../Elements/UI/FeedSkeleton'
import DeleteButton from '../Elements/UI/DeleteButton'
import Pollmodal from '../Modals/Pollmodal'
import ConformationPollmodal from '../Modals/Conformationpollmodal'
import config from '../../config'
import { connect } from 'react-redux'

function PollPage({ userAccess = [] }) {
  const wideBlockRef = useRef()
  const [showModal, setShowModal] = React.useState(false)
  const [selectId, setSelectId] = React.useState(null)
  const [showConfirmModal, setShowConfirmModal] = React.useState(false)
  const [deleteId, setDeleteId] = React.useState(null)

  const [loading, setLoading] = React.useState(true)
  const [pollData, setPollData] = React.useState([])
  const [inputData, setInputData] = React.useState([])

  useEffect(() => {
    fetchmypolls().finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    if (showModal) {
      fetchinputs()
    }
  }, [showModal])

  const fetchmypolls = async () => {
    const token = localStorage.getItem('token')

    try {
      const res = await axios.get(config.apiUrl + '/post/getAll/Vote', {
        headers: { Authorization: token }
      })
      

      console.log('FULL API RESPONSE:', res.data.data)

      const normalized = (res.data.data || [])
        .map(post => ({
          pollId: post.ID,
          question: post.Data?.Question?.trim(),
          expiry: post.Data?.ExpiryDateTime || '',
          MySubmission: post?.MySubmission,
          Submissions: post?.Data?.Submissions,
          options: (post.Data?.Options || [])
            .filter(Boolean)
            .map((opt, index) => ({
              optionId: index,
              label: opt,
              votes: post?.Data?.Submissions ? (post.Data.Submissions[opt] ?? 0) : 0
            }))
        }))
        .filter(poll => poll.question && poll.options.length > 0)
        .sort((a, b) => b.pollId - a.pollId)
         console.log({normalized})
         setPollData(normalized)

      // setPollData(prevsetPoll => [...normalized,...prevsetPoll])
    } catch (err) {
      console.error(err)
      toast.error('Failed to fetch polls')
    }
  }

  useEffect(() => {
    const updateHeight = () => {
      const fullHeight = window.innerHeight
      const offset = 100 // adjust this based on your header or spacing
      if (wideBlockRef.current) {
        wideBlockRef.current.style.maxHeight = `${fullHeight - offset}px`
      }
    }

    updateHeight()
    window.addEventListener('resize', updateHeight)

    return () => window.removeEventListener('resize', updateHeight)
  }, [])

  console.log(userAccess)

  const handleSubmitPoll = async pollPayload => {
    const token = localStorage.getItem('token')

    try {
      const res = await axios.post(`${config.apiUrl}/post/Vote`, pollPayload, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json'
        }
      })

      toast.success('Poll created successfully!')
      setShowModal(false)

      const post = res.data?.data

      if (post) {
        const newPoll = {
          pollId: post.ID,
          question: post.Data?.Question || '',
          expiry: post.Data?.ExpiryDateTime || '',
          options: (post.Data?.Options || []).map((opt, index) => ({
            optionId: index,
            label: opt,
            votes: 0
          }))
        }

        if (
          newPoll.question &&
          newPoll.options &&
          newPoll.options.length >= 2
        ) {
          setPollData(prev => [newPoll, ...prev])
        } else {
          fetchmypolls() // fallback
        }
      }
    } catch (error) {
      console.error(error)
      toast.error(error.response?.data?.message || 'Failed to create poll')
    }
  }

  const handlemodalOpen = id => {
    setSelectId(id)
    setShowModal(true)
  }

  const handleDeleteModal = pollID => {
    setDeleteId(pollID)
    setShowConfirmModal(true)
  }

  const fetchinputs = async () => {
    const token = localStorage.getItem('token')

    try {
      const res = await axios.get(`${config.apiUrl}/projects/projects-with-wings`, {
        headers: { Authorization: token }
      })
       console.log('FULL API RESPONSE:', res.data)
       const normalized = (res.data || []).flatMap(project =>
       (project.Wings || []).map(wing => ({
        projectId:project.ID,
        projectName: project.Name.trim(),
        wingId: wing.ID,
        wingName: wing.Name
       }))
      ) 
      setInputData(normalized);
    } catch (err) {
      console.error(err)
      toast.error('Failed to fetch posts')
    }
  }


  const handleConfirmDelete = async () => {
  if (!deleteId) return;

  const token = localStorage.getItem('token');

  try {
    await axios.delete(`${config.apiUrl}/post/${deleteId}`, {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    });

    setPollData(prev =>
      prev.filter(item => item.pollId !== deleteId)
    );

    toast.success('Poll deleted successfully!');
    setShowConfirmModal(false);
    setDeleteId(null);
  } catch (e) {
    console.error(e);
    toast.error('Failed to delete poll');
  }
};

  const handleCancelDelete = () => {
    setShowConfirmModal(false)
    setDeleteId(null)
  }

  const canDelete = Array.isArray(userAccess) && userAccess.includes('DeleteVote')

  return (
    <div id="appCapsule">
      <div className="section full mt-1">

        <div className="wide-block mt-1" ref={wideBlockRef}>
          <PageHeader title="Polls" subtitle="Vote on society decisions" />

          {loading && <FeedSkeleton label="Loading polls" />}

          {!loading && (!Array.isArray(pollData) || pollData.length === 0) && (
            <EmptyState icon="bar-chart-outline" title="No active polls" text="New items will appear here once they are posted." />
          )}

          <div className="timeline timed">
            {Array.isArray(pollData) &&
              pollData.map(item => (
                <div className="item" key={item.pollId}>
                  <span className="time">{item.expiry}</span>
                  <div className={`dot ${item.dotColor}`} aria-hidden="true"></div>

                  <div className="content">
                    <article className={`card bl-feed-card${canDelete ? ' has-action' : ''}`}>
                      {canDelete && (
                        <DeleteButton onClick={() => handleDeleteModal(item.pollId)} label="Delete poll" />
                      )}

                      {item.question && item.options?.length > 0 && (
                        <PollQuestion
                          pollID={item.pollId}
                          question={item.question}
                          options={item.options}
                          MySubmission={item?.MySubmission?.Data?.SelectedOption}
                          onVoteSuccess={fetchmypolls}
                        />
                      )}
                    </article>
                  </div>
                </div>
              ))}
          </div>
        </div>
        {userAccess.includes('CreateVote') && (
          <Floatingbutton onOpen={handlemodalOpen} />
        )}
        
        <Pollmodal
          show={showModal}
          userId={selectId}
          onClose={() => setShowModal(false)}
          inputData={inputData}     
          fetchinputs={fetchinputs} 
          onSubmitPoll={handleSubmitPoll}
        />     
        <ConformationPollmodal
            show={showConfirmModal}
            onClose={handleCancelDelete}
            onConfirm={handleConfirmDelete}
        />
      </div>
    </div>
  )
}

const mapStateToProps = ({ auth }) => {
  const { userAccess } = auth
  return {
    userAccess
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(PollPage)
